// extracted by mini-css-extract-plugin
module.exports = {"header":"header-bBuXS","close":"close-1JcsM"};